module.exports = __webpack_public_path__ + "static/media/0040.03bc65c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48010/RAL/0040.png
// module id = 454
// module chunks = 0